import { useEffect, useState } from "react";
import { fetchBlackLists } from "@api/procurements/vendor";

export const useBlackList = (id: string | number) => {
  const [getData, setGetData] = useState<any[]>([]);
  const [getError, setGetError] = useState(false);
  const [getDataAfterUpdate, setGetDataAfterUpdate] = useState(false);
  useEffect(() => {
    if (id) {
      fetchBlackLists(id)
        .then((data: any) => {
          setGetData(data?.data?.data);
        })
        .catch((err: any) => {
          setGetError(true);
        });
    }
  }, [id]);

  useEffect(() => {
    if (id && getDataAfterUpdate) {
      fetchBlackLists(id)
        .then((data: any) => {
          setGetData(data?.data?.data);
          setGetDataAfterUpdate(false);
        })
        .catch((err: any) => {
          setGetError(true);
        });
    }
  }, [id, getDataAfterUpdate]);

  return {
    getData,
    getError,
    setGetDataAfterUpdate,
  };
};
